module.exports = __webpack_public_path__ + "64f3b20b3233c6aca49271c397957aa8.png";